export default "__VITE_ASSET__BFMhD9oh__"